
var winWidth = window.innerWidth;
console.log(winWidth);

$(window).on('resize load', function(){
  winWidth = window.innerWidth;
});


/* ----------------- PC Header メニュー のマウスオーバーでのメニュー表示 ----------------- */

//コレクションリンクに在庫有りパラメータを足す処理を全ての a にしていて、区別のためのフラグ
var isPageTransition = true;

//PCとSPで処理変え
if(winWidth > 960){
  $('.hps_header_nav_one').on('mouseenter', function(){
    $(this).children('.hps_header_nav_hide').stop().slideDown(200);
  });
  $('.hps_header_nav_one').on('mouseleave', function(){
    $(this).children('.hps_header_nav_hide').stop().slideUp(200);
  });
}else{
  $('.hps_header_nav_name_more').on('click', function(){
    $(this).toggleClass("open");
    $(this).next('.hps_header_nav_hide').stop().slideToggle(200);
  });
  $('.gnav_category_list_.category li dl dt a').on('click', function(e){
    isPageTransition = false;
    e.preventDefault();
    $(this).toggleClass("open");
    $(this).parent("dt").next('dd').stop().slideToggle(200);
  });
}

/* ------------------- 右下固定バナー ------------------- */

var fixedBanner = $('.fixed_banner'); 
//スクロールが100に達したらボタン表示
$(window).scroll(function () {
  if ($(this).scrollTop() > 100) {
    fixedBanner.addClass("is-show");
  } else {
    fixedBanner.removeClass("is-show");
  }
});
$('.fixed_banner_close').on('click', function() {
  fixedBanner.hide();
});

/* ------------------- SP用メニュー関連 ------------------- */

$('#spMenuOpen').on('click', function() {
  $('.hps_sp_menu_wrap').addClass("active");
});
$('.hps_sp_menu_close, .hps_sp_menu_content_left_side').on('click', function() {
  $('.hps_sp_menu_wrap').removeClass("active");
});

/* ------------------- コレクションに遷移するリンクに 在庫あり パラメータを付ける ------------------- */

const inStockSortParameter = 'filter.v.availability=1';
$(document).on('click', 'a', function(e) {
  var href = $(this).attr("href");
  var isPaginate = $(this).parents(".pagination");
  var topCateContents = $(this).parents(".top_cate_contents").length;
  if(href.includes("/collections/") && !href.includes("/products/") && isPaginate.length < 1 && isPageTransition){
    e.preventDefault();
    var addParam = '';
    if(href.includes("?")){
      if(!href.includes("filter.v.availability")){
        addParam = '&' + inStockSortParameter;
      }
    }else{
      addParam = '?' + inStockSortParameter;
    }
    const linkUrl = href + addParam;
    location.href = linkUrl;
  }else{
    isPageTransition = true;
  }
});


